import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponseHasPaginatedSchema } from '@/shared/api/validation'
import { paginatedAssetSchema } from '@/features/assets/schemas'
import type { SortedField } from '@/types'
import { objectWithoutKeys } from '@/helpers'

const client = createAssetManagementClient()

type Options = {
  page: number
  pageSize: number
  filter?: string
  sorting?: SortedField[]
  owner?: number
}

export const fetchPaginatedAssets = (options: Options) => validateResponseHasPaginatedSchema(
  client.sendGet('v2/assets', {
    ...objectWithoutKeys(options, ['pageSize', 'sorting']),
    limit: options.pageSize,
    sort: options.sorting ?? []
  }),
  paginatedAssetSchema,
).then(
  res => ({ items: res.data, meta: res.meta })
)
